import React from 'react';
import isChromatic from 'chromatic/isChromatic';

import { BankIcon } from '@motorway/mw-highway-code';

import { FAQExpandable } from './FAQExpandable';

export const FAQThirdSection: React.FC = () => {
	return (
		<FAQExpandable
			content={
				<>
					<p>
						Yes, Motorway makes it much simpler to pay for financed cars. You make one payment and we will clear the
						finance with the lender, and pay any surplus to the seller (or, in the case of negative equity, collect the
						balance from the seller).
					</p>
					<p>
						Payments to finance houses are sent within 15 minutes during our operating hours. Although it can take a
						short while for finance houses to acknowledge that the finance is cleared, we send proof of payment to both
						you and the seller, for peace of mind.
					</p>
				</>
			}
			defaultIsExpanded={Boolean(isChromatic())}
			heading="Can I pay for vehicles with outstanding finance?"
			icon={BankIcon}
			id="secondExpandable"
		/>
	);
};
